module.exports = __webpack_public_path__ + "media/assets_v3/images/buy-ad-image-active-2a0b1e026fa8c66b8970fed6645515c3.jpeg";